var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 117,
    viewBox: "0 0 136 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5854 53.1914C57.5757 49.2305 62.3806 47.25 68 47.25C73.6194 47.25 78.4243 49.2305 82.4146 53.1914C86.4049 57.1523 88.4 61.9219 88.4 67.5C88.4 73.0781 86.4049 77.8477 82.4146 81.8086C78.4243 85.7695 73.6194 87.75 68 87.75C62.3806 87.75 57.5757 85.7695 53.5854 81.8086C49.5951 77.8477 47.6 73.0781 47.6 67.5C47.6 61.9219 49.5951 57.1523 53.5854 53.1914ZM102 18H117.867C122.872 18 127.146 19.7578 130.687 23.2734C134.229 26.7891 136 31.0313 136 36V99C136 103.969 134.229 108.211 130.687 111.727C127.146 115.242 122.872 117 117.867 117H18.1333C13.1278 117 8.85417 115.242 5.3125 111.727C1.77083 108.211 0 103.969 0 99V36C0 31.0313 1.77083 26.7891 5.3125 23.2734C8.85417 19.7578 13.1278 18 18.1333 18H34L37.6125 8.4375C38.5097 6.14062 40.1507 4.16016 42.5354 2.49609C44.9201 0.832031 47.3639 0 49.8667 0H86.1333C88.6361 0 91.0799 0.832031 93.4646 2.49609C95.8493 4.16016 97.4903 6.14062 98.3875 8.4375L102 18ZM45.5812 89.7539C51.791 95.918 59.2639 99 68 99C76.7361 99 84.209 95.918 90.4187 89.7539C96.6285 83.5898 99.7333 76.1719 99.7333 67.5C99.7333 58.8281 96.6285 51.4102 90.4187 45.2461C84.209 39.082 76.7361 36 68 36C59.2639 36 51.791 39.082 45.5812 45.2461C39.3715 51.4102 36.2667 58.8281 36.2667 67.5C36.2667 76.1719 39.3715 83.5898 45.5812 89.7539Z",
    fill: "#D7D7D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 117,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCamera);
export default __webpack_public_path__ + "static/media/whiteCamera.3c529abb4e9425f5823d1d41cb86a4d0.svg";
export { ForwardRef as ReactComponent };